import { Outlet } from 'react-router';

import SubPagePreLoader from '@/_containers/sub-page-loader';

import { useBridgePlan } from './actions';
import { BridgePlanContext } from './context';

export function BridgePlanProvider() {
  const bridgePlan = useBridgePlan();

  const showLoader = false;
  return (
    <BridgePlanContext.Provider value={bridgePlan}>
      {showLoader ? <SubPagePreLoader /> : <Outlet />}
    </BridgePlanContext.Provider>
  );
}
